/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "gëschter",
      "0": "haut",
      "1": "muer",
      "future": {
        "one": "an {0} Dag",
        "other": "a(n) {0} Deeg"
      },
      "past": {
        "one": "virun {0} Dag",
        "other": "viru(n) {0} Deeg"
      }
    },
    "day-narrow": {
      "-1": "gëschter",
      "0": "haut",
      "1": "muer",
      "future": {
        "one": "+{0} D.",
        "other": "+{0} D."
      },
      "past": {
        "one": "-{0} D.",
        "other": "-{0} D."
      }
    },
    "day-short": {
      "-1": "gëschter",
      "0": "haut",
      "1": "muer",
      "future": {
        "one": "an {0} D.",
        "other": "a(n) {0} D."
      },
      "past": {
        "one": "virun {0} D.",
        "other": "viru(n) {0} D."
      }
    },
    "hour": {
      "0": "this hour",
      "future": {
        "one": "an {0} Stonn",
        "other": "a(n) {0} Stonnen"
      },
      "past": {
        "one": "virun {0} Stonn",
        "other": "viru(n) {0} Stonnen"
      }
    },
    "hour-narrow": {
      "0": "this hour",
      "future": {
        "one": "+{0} St.",
        "other": "+{0} St."
      },
      "past": {
        "one": "-{0} St.",
        "other": "-{0} St."
      }
    },
    "hour-short": {
      "0": "this hour",
      "future": {
        "one": "an {0} St.",
        "other": "a(n) {0} St."
      },
      "past": {
        "one": "virun {0} St.",
        "other": "viru(n) {0} St."
      }
    },
    "minute": {
      "0": "this minute",
      "future": {
        "one": "an {0} Minutt",
        "other": "a(n) {0} Minutten"
      },
      "past": {
        "one": "virun {0} Minutt",
        "other": "viru(n) {0} Minutten"
      }
    },
    "minute-narrow": {
      "0": "this minute",
      "future": {
        "one": "+{0} Min.",
        "other": "+{0} Min."
      },
      "past": {
        "one": "-{0} Min.",
        "other": "-{0} Min."
      }
    },
    "minute-short": {
      "0": "this minute",
      "future": {
        "one": "an {0} Min.",
        "other": "a(n) {0} Min."
      },
      "past": {
        "one": "virun {0} Min.",
        "other": "viru(n) {0} Min."
      }
    },
    "month": {
      "-1": "leschte Mount",
      "0": "dëse Mount",
      "1": "nächste Mount",
      "future": {
        "one": "an {0} Mount",
        "other": "a(n) {0} Méint"
      },
      "past": {
        "one": "virun {0} Mount",
        "other": "viru(n) {0} Méint"
      }
    },
    "month-narrow": {
      "-1": "leschte Mount",
      "0": "dëse Mount",
      "1": "nächste Mount",
      "future": {
        "one": "+{0} M.",
        "other": "+{0} M."
      },
      "past": {
        "one": "-{0} M.",
        "other": "-{0} M."
      }
    },
    "month-short": {
      "-1": "leschte Mount",
      "0": "dëse Mount",
      "1": "nächste Mount",
      "future": {
        "one": "an {0} M.",
        "other": "a(n) {0} M."
      },
      "past": {
        "one": "virun {0} M.",
        "other": "viru(n) {0} M."
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "one": "an {0} Quartal",
        "other": "a(n) {0} Quartaler"
      },
      "past": {
        "one": "virun {0} Quartal",
        "other": "viru(n) {0} Quartaler"
      }
    },
    "quarter-narrow": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "one": "+{0} Q.",
        "other": "+{0} Q."
      },
      "past": {
        "one": "-{0} Q.",
        "other": "-{0} Q."
      }
    },
    "quarter-short": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "one": "an {0} Q.",
        "other": "a(n) {0} Q."
      },
      "past": {
        "one": "virun {0} Q.",
        "other": "viru(n) {0} Q."
      }
    },
    "second": {
      "0": "now",
      "future": {
        "one": "an {0} Sekonn",
        "other": "a(n) {0} Sekonnen"
      },
      "past": {
        "one": "virun {0} Sekonn",
        "other": "viru(n) {0} Sekonnen"
      }
    },
    "second-narrow": {
      "0": "now",
      "future": {
        "one": "+{0} Sek.",
        "other": "+{0} Sek."
      },
      "past": {
        "one": "-{0} Sek.",
        "other": "-{0} Sek."
      }
    },
    "second-short": {
      "0": "now",
      "future": {
        "one": "an {0} Sek.",
        "other": "a(n) {0} Sek."
      },
      "past": {
        "one": "virun {0} Sek.",
        "other": "viru(n) {0} Sek."
      }
    },
    "week": {
      "-1": "lescht Woch",
      "0": "dës Woch",
      "1": "nächst Woch",
      "future": {
        "one": "an {0} Woch",
        "other": "a(n) {0} Wochen"
      },
      "past": {
        "one": "virun {0} Woch",
        "other": "viru(n) {0} Wochen"
      }
    },
    "week-narrow": {
      "-1": "lescht Woch",
      "0": "dës Woch",
      "1": "nächst Woch",
      "future": {
        "one": "+{0} W.",
        "other": "+{0} W."
      },
      "past": {
        "one": "-{0} W.",
        "other": "-{0} W."
      }
    },
    "week-short": {
      "-1": "lescht Woch",
      "0": "dës Woch",
      "1": "nächst Woch",
      "future": {
        "one": "an {0} W.",
        "other": "a(n) {0} W."
      },
      "past": {
        "one": "virun {0} W.",
        "other": "viru(n) {0} W."
      }
    },
    "year": {
      "-1": "lescht Joer",
      "0": "dëst Joer",
      "1": "nächst Joer",
      "future": {
        "one": "an {0} Joer",
        "other": "a(n) {0} Joer"
      },
      "past": {
        "one": "virun {0} Joer",
        "other": "viru(n) {0} Joer"
      }
    },
    "year-narrow": {
      "-1": "lescht Joer",
      "0": "dëst Joer",
      "1": "nächst Joer",
      "future": {
        "one": "+{0} J.",
        "other": "+{0} J."
      },
      "past": {
        "one": "-{0} J.",
        "other": "-{0} J."
      }
    },
    "year-short": {
      "-1": "lescht Joer",
      "0": "dëst Joer",
      "1": "nächst Joer",
      "future": {
        "one": "an {0} J.",
        "other": "a(n) {0} J."
      },
      "past": {
        "one": "virun {0} J.",
        "other": "viru(n) {0} J."
      }
    }
  },
  "locale": "lb"
})
}
